import _ from 'lodash';

export function groupProductionReportsByOrder(productionReports: any[]): any {
  if(productionReports.length == 0) return [];
  const filteredProductionReports = productionReports.filter((prodRep: any) => prodRep.process.inputs.length > 0);
  const groupedProductionReports =  _.groupBy(filteredProductionReports, 'factoryTicket.order._id');
  const arr: any[] = [];
   _.forEach(groupedProductionReports, (productionReportGroup) => {
    const order = _.get(productionReportGroup, '0.factoryTicket.order')
    if(order) arr.push({ order, productionReports: productionReportGroup, noOfProductionReports: productionReportGroup.length });
  })
  return arr;
}